"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDragState = void 0;
var utils_1 = require("../../../utils");
exports.IDragState = (0, utils_1.IRecord)({
    dragging: false,
    start: (0, utils_1.IPos)(),
    end: (0, utils_1.IPos)(),
    vector: (0, utils_1.IVector2d)()
});
